interface KeyboardHandlerOptions {
	onToggleTerminal: () => void;
	onTogglePalette: () => void;
	onSecretCode: () => void;
}

/**
 * Creates a keydown handler for global keyboard shortcuts.
 * Tracks key sequences for the secret "ameta" code and handles
 * Ctrl/Cmd+K (palette) and Ctrl/Cmd+. (terminal) shortcuts.
 */
export function createKeyboardHandler(options: KeyboardHandlerOptions) {
	let keySequence = '';
	let clearTimer: ReturnType<typeof setTimeout>;

	return (e: KeyboardEvent) => {
		// Ctrl+K or Cmd+K to toggle command palette
		if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
			e.preventDefault();
			options.onTogglePalette();
			return;
		}

		// Ctrl+. or Cmd+. to toggle terminal
		if ((e.ctrlKey || e.metaKey) && e.key === '.') {
			e.preventDefault();
			options.onToggleTerminal();
			return;
		}

		// Secret code: typing "ameta" opens terminal
		if (!e.ctrlKey && !e.metaKey && !e.altKey && e.key.length === 1) {
			clearTimeout(clearTimer);
			keySequence = (keySequence + e.key.toLowerCase()).slice(-5);
			if (keySequence === 'ameta') {
				options.onSecretCode();
				keySequence = '';
			}
			// Reset after 2 seconds of inactivity
			clearTimer = setTimeout(() => {
				keySequence = '';
			}, 2000);
		}
	};
}
